import { Typography, Breadcrumbs } from '@mui/material';
import './index.css';
import React from 'react';
import { useLocation } from 'react-router-dom';

function AppBreadcrumb(): JSX.Element {
  const locations = useLocation().pathname.split('/').filter(String);
  const section = locations[0];
  const objName = locations[locations.length - 2];
  const action = locations[locations.length - 1];

  let sectionLink;
  let objLink;
  const typography = <Typography>{action}</Typography>;

  if (objName && objName !== '') {
    sectionLink = <Typography>{section}</Typography>;
    objLink = <Typography>{objName}</Typography>;
  }

  return (
    <div role='presentation'>
      <Breadcrumbs aria-label='breadcrumb' className='app-breadcrumb_root'>
        {sectionLink}
        {objLink}
        {typography}
      </Breadcrumbs>
    </div>
  );
}

export default AppBreadcrumb;
